import { Box, Button, Flex, Grid, Hide, Text } from '@chakra-ui/react';
import { IPlanAdd, PriceCard } from '@shared/components';
import { links } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useCreateRequestPlanInput } from '../../hooks';
import { IPlanPayload } from '../../services';
import { useCheckoutState } from '../../store';

import { PlansMyProducts } from './PlansMyProducts';

interface IPlansListProps {
  data: IPlanPayload;
}

export const PlansList = ({ data }: IPlansListProps) => {
  const { t } = useTranslation(['checkout/plans', 'common']);
  const navigate = useNavigate();
  const { setSelectedPlans, selectedPlans } = useCheckoutState();
  const { mutate: createRequestPlanInput, isLoading } =
    useCreateRequestPlanInput();

  const getSelectePlanById = (id: string) =>
    selectedPlans.find(plan => plan.planDurationId === id);

  const handleAdd = (plan: IPlanAdd) => {
    const existPlan = getSelectePlanById(plan.planDurationId);

    const planWithoutCurrent = selectedPlans.filter(
      item => item.planDurationId !== plan.planDurationId,
    );

    if (existPlan) {
      const currentPlan = {
        ...existPlan,
        quantity: existPlan.quantity + plan.quantity,
      };
      setSelectedPlans([...planWithoutCurrent, currentPlan]);
    } else {
      setSelectedPlans([...planWithoutCurrent, plan]);
    }
  };

  const handleNextStep = () => {
    createRequestPlanInput(selectedPlans, {
      onSuccess: () => {
        navigate(links.checkout.data);
      },
    });
  };

  return (
    <Flex flexDir="column" gap={4}>
      <Text
        color="brand.800"
        fontSize="2xl"
        fontWeight={600}
        textAlign={{ base: 'center', lg: 'start' }}
      >
        {t('checkout/plans:availablePlans')}
      </Text>

      <Box
        maxH={{ base: 'calc(100dvh - 186px)', lg: 'calc(100dvh - 214px)' }}
        h={{ lg: '100dvh' }}
        overflowY="auto"
      >
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            xl: 'repeat(2, 1fr)',
            '2xl': 'repeat(3, 1fr)',
          }}
          gap={4}
        >
          {data.length <= 0 && (
            <Text color="neutral.700" fontSize="lg" fontWeight="regular">
              Nenhum plano encontrado
            </Text>
          )}
          {data.map(plan => (
            <PriceCard
              key={plan.id}
              id={plan.id}
              title={plan.title}
              description={plan.description}
              plans={plan.planDurations}
              onAdd={handleAdd}
            />
          ))}
          <Hide above="lg">
            <PlansMyProducts />

            <Button
              onClick={handleNextStep}
              colorScheme="brand"
              isLoading={isLoading}
              isDisabled={selectedPlans.length === 0}
              w="full"
            >
              {t('common:continue')}
            </Button>
          </Hide>
        </Grid>
      </Box>

      <Flex justifyContent="end">
        <Button
          onClick={handleNextStep}
          colorScheme="brand"
          w={240}
          isLoading={isLoading}
          isDisabled={selectedPlans.length === 0}
          display={{ base: 'none', lg: 'flex' }}
        >
          {t('common:continue')}
        </Button>
      </Flex>
    </Flex>
  );
};
